var map = {
	"./logo-dark.svg": 9655,
	"./logo-light.svg": 2080,
	"./logo-mobile-dark.svg": 2850,
	"./logo-mobile-light.svg": 41,
	"./logo-without-dark.svg": 4915,
	"./logo-without-light.svg": 2611,
	"./look-dark.svg": 8496,
	"./look-light.svg": 6661,
	"./main-logo.svg": 7087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7631;